module.exports = __webpack_public_path__ + "img/daily-blockchain.5a574425.gif";